import { Flex, FlexProps } from "@biblioteksentralen/react";
import { useTranslation } from "../../../utils/hooks/useTranslation";

type Props = FlexProps & { href: string; popupWidth?: number; popupHeight?: number };

export const PopupLink = ({ href, children, popupWidth = 1000, popupHeight = 800, ...flexProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex
      {...flexProps}
      justifyContent="center"
      alignItems="center"
      position="relative"
      asChild
      _hover={{ opacity: 0.7 }}
    >
      <a
        href={href}
        target="_blank"
        onClick={(event) => {
          window.open(href, "newwindow", `width=${popupWidth},height=${popupHeight}`);
          event.preventDefault();
          event.stopPropagation();
          return false;
        }}
        aria-label={t("Del på {sosialtMedie}", { sosialtMedie: "Facebook" })}
      >
        {children}
      </a>
    </Flex>
  );
};
